import LinkButton from '@carvana/ds-link-button';
import { useContext } from 'react';
import Section from '~/constants/vdp/section';
import { useUserLocation } from '~/context/common/UserContext';
import ModalContext from '~/context/vdp/ModalContext';
import { Separator } from './Terms/Terms.styles';

type OwnProps = {
  hideDot?: boolean;
};

export default function ShippingTo({ hideDot = false }: OwnProps) {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { zip } = useUserLocation();

  return (
    <div className="flex items-center gap-sm">
      {!hideDot && <Separator className="bg-icon-default" />}
      <div className="flex items-center gap-sm" data-testid="shipping-to-zip">
        Shipping to{' '}
        <LinkButton
          data-adobe-id="shipping-to-zip"
          data-analytics-id={Section.VehicleInfo}
          data-analytics-attributes={JSON.stringify({
            action: 'clicked',
            description: 'Change location',
            text: zip
          })}
          data-testid="shipping-to-change-location"
          onClick={() => setGeolocationModalOpen(true)}
          size="sm"
          variant="default"
          underline={false}
        >
          {zip}
        </LinkButton>
      </div>
    </div>
  );
}
